import React from 'react';
import type CustomSettingsType from '@atlassian/jira-spa-apps-project-settings-custom-filters/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyCustomFiltersSettings = lazyForPaint<typeof CustomSettingsType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-custom-filters", jiraSpaEntry: "async-project-settings-custom-filters" */ '@atlassian/jira-spa-apps-project-settings-custom-filters'
		),
);

const AsyncCustomFiltersSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyCustomFiltersSettings}
		pageId="project-settings-custom-filters"
		shouldShowSpinner
	/>
);

export default AsyncCustomFiltersSettings;
